import _ from 'lodash';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  PRODUCTS_VIEW_TYPE,
  getProductPriceTitle,
  resolveHoverProductImage,
  resolveProductImage,
  routeToProduct,
  ecommerceAddToCartEvent,
  esputnikAddToCartShop,
  generateVisitorId,
  getCookie,
  hasVisibleDiscount
} from '@/helpers';
import { MEDIA } from '@/helpers/variables';
import moment from 'moment';

import IconHeart from '@/components/icons/IconHeart.vue';
import IconDelete from '@/components/icons/IconDelete.vue';
import TypeSelect from '@/components/custom/TypeSelect/index.vue';
import IconInfo from '@/components/icons/IconInfo.vue';
import IconPromoChristmas from '@/components/icons/IconPromoChristmas.vue';
import raffleIcon from '@/assets/img/raffle/raffle-badge.png';

export default {
  name: 'ProductCard',
  components: {
    IconPromoChristmas,
    IconInfo,
    IconDelete,
    IconHeart,
    TypeSelect
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    hover: {
      type: Boolean,
      default: true
    },
    isProductDesc: {
      type: Boolean,
      default: false
    },
    viewType: {
      type: String,
      default: PRODUCTS_VIEW_TYPE.GRID
    },
    titleTag: {
      type: String,
      default: 'h3'
    }
  },

  data() {
    return {
      raffleIcon,
      PRODUCTS_VIEW_TYPE,
      MEDIA,
      isProductPriceInBasket: false,
      selectedProductPrice: null,
      favoriteSelect: false,
      basketKey: 1,
      leftoverType: null
    };
  },
  created() {
    if (this.product.productPrices?.data.length) {
      let { data: productPrices } = this.product.productPrices;
      let sortedProductPrices = _.orderBy(productPrices, ['value'], ['asc']);
      let defaultPrice = sortedProductPrices[0];
      let outletPrice = null;

      if (['outlet', 'outlet-paginated'].includes(this.$route.name)) {
        console.log();
        outletPrice = sortedProductPrices.find((obj) => obj.outletReasons?.data?.length);
      }
      this.selectProductPrice(outletPrice || defaultPrice);
    }
  },
  watch: {
    selectedProductPrice: function () {
      this.$router.query = this.selectedProductPrice.value;
      this.selectProductPrice(this.selectedProductPrice);
    },
    basket: function () {
      this.basketKey += 1;
      this.checkProductInBasket();
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      basket: 'basket/basket',
      user: 'profile/user',
      userEmailByVisitorUUID: 'profile/userEmailByVisitorUUID',
      showNotifyLoader: 'products/showNotifyLoader',
      appSize: 'app/size'
    }),
    isOutlet() {
      return this.selectedProductPrice?.outletReasons?.data?.length;
    },
    isHasVisibleDiscount() {
      return hasVisibleDiscount(this.selectedProductPrice);
    },
    isHasDuplicate() {
      return this.product.hasDuplicate;
    },
    isOutStock() {
      return this.leftoverType.displayType === 'out-stock';
    },
    isProfessionalOnly() {
      return this.selectedProductPrice && this.selectedProductPrice.showWithoutPrice;
    },
    isCanBePurchased() {
      return !this.isOutStock && !this.isHasDuplicate && !this.isProfessionalOnly;
    },
    isDiscontinued() {
      return this.product.discontinued;
    },
    isHasAnalogue() {
      return this.product.analogueProduct && this.product.analogueProduct.data;
    },
    isComingSoon() {
      return this.product.isComingSoon;
    },
    outlets() {
      return this.selectedProductPrice?.outletReasons?.data || [];
    },
    promotions() {
      let activities = this.selectedProductPrice?.promotion?.activities?.data || [];

      let dateNow = moment();

      return activities.filter((activity) => {
        let dateFrom = moment.utc(activity.dateFrom);
        let dateTo = moment.utc(activity.dateTo);

        return dateNow.isBetween(dateFrom, dateTo, null, '[)');
      });
    },
    productPriceTitle() {
      let title = getProductPriceTitle(this.selectedProductPrice);
      if (this.isOutlet) title = `${title} - outlet`;
      return title;
    },
    showRaffleIcon() {
      return new Date() <= new Date(2026, 9, 31, 23, 59, 59);
    }
  },

  methods: {
    getProductPriceTitle,
    ...mapActions({
      addToFavorite: 'favorites/ADD_PRODUCT_TO_FAVOURITES',
      removeFromFavorite: 'favorites/REMOVE_PRODUCT_IN_FAVORITE',
      getFavorites: 'favorites/GET_FAVORITES_LIST',
      showNotifyPopup: 'products/SHOW_POPUP_PRODUCT_WHEN_AVAILABLE',
      getUserEmailByVisitorUUID: 'profile/GET_USER_EMAIL_BY_VISITOR_UUID'
    }),
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      modalOpen: 'app/MODAL_OPEN'
    }),

    routeToProduct: routeToProduct,
    resolveProductImage: resolveProductImage,
    resolveHoverProductImage: resolveHoverProductImage,
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice;
      this.leftoverType = productPrice.leftoverType.data;
      this.checkProductInBasket();
    },
    openFastBuy() {
      this.changeFastBuyPopup({
        show: true,
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.product
        }
      });
    },
    checkProductInBasket() {
      this.basketKey += 2;
      this.isProductPriceInBasket = _.some(this.basket, { select_type: { id: this.selectedProductPrice.id } });
    },

    onShowNotify() {
      const payload = {
        product_id: this.product.id,
        product_price_id: this.selectedProductPrice.id
      };

      this.showNotifyPopup(payload);
    },
    onChangeFavorite() {
      if (this.isAuthenticated) {
        const index = this.favourites.find((e) => e.productId === this.product.id);
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites();
            this.favoriteSelect = false;
            this.$toasted.success(this.$t('toast.successRemoveFromFavorite'));
          });
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true;
            this.$toasted.success(this.$t('toast.successAddToFavorites'));
            this.getFavorites();
          });
        }
      } else {
        this.changeLoginPopup(true);
      }
    },
    async onAddBasket() {
      this.addToBasket({
        select_count: 1,
        product_price: this.selectedProductPrice,
        product: this.product,
        unauthorizedProductPriceId: this.product.unauthorizedProductPriceId
      });

      ecommerceAddToCartEvent({
        item_id: this.selectedProductPrice.id,
        item_name: this.product.title,
        item_brand: this.product.brandSeries?.title || 'Renew',
        item_category: this.product.brand?.title || '',
        item_variant: this.selectedProductPrice.title,
        price: this.selectedProductPrice.price,
        content_ids: this.product.unauthorizedProductPriceId
      });

      //---ESputnik

      let visitorId = getCookie('visitorUUID');
      if (!visitorId) {
        visitorId = generateVisitorId();
      }

      let esputnikPayload = {
        keyValue: visitorId,
        params: []
      };

      esputnikPayload.params.push({
        name: 'externalCustomerId',
        value: visitorId
      });

      let userEmail = this.user?.email || this.userEmailByVisitorUUID;

      console.log('userEmail1', { userEmail });

      if (!userEmail) {
        await this.getUserEmailByVisitorUUID();
        userEmail = this.userEmailByVisitorUUID;
      }
      console.log('userEmail2', { userEmail });

      if (userEmail) {
        esputnikPayload = { ...esputnikPayload, keyValue: userEmail };
        esputnikPayload.params.push({
          name: 'EmailAddress',
          value: userEmail
        });
      }

      let { uaTitle, image, brand } = this.product;

      esputnikPayload.params.push(
        {
          name: 'productName',
          value: uaTitle
        },
        {
          name: 'categoryName',
          value: brand ? brand.title : ''
        },
        {
          name: 'Price',
          value: this.selectedProductPrice.price
        },
        {
          name: 'URL',
          value: window.location.href
        },
        {
          name: 'imageURL',
          value: image
        }
      );

      esputnikAddToCartShop(esputnikPayload);

      this.modalOpen('basketModal');
      this.checkProductInBasket();
      // this.$toasted.success(this.$t('toast.successAddBasket'));
    }
  }
};
